import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HdfcApiService } from '../common/hdfc-api/hdfc-api.service';
import { API_CAPTCHA, API_LOGIN_ADMIN, API_LOGIN_LP, API_LOGIN_LP_CRED, API_LOGIN_LP_GPAY, API_LOGIN_LP_PHONEPE, API_LOGOUT_ADMIN, API_LP_CPL, API_MOBILE_DEVICEID, API_REFRESH_ADMIN, API_START_PARTNER, API_VALIDATE_PARTNER,API_LOGIN_LP_2In1,API_GETPARTNERCATEGORY,API_VALIDATE_PARTNEREMAIL, API_GETSTATENAME, API_LPURLDATA } from '../common/hdfc-api/hdfc-api-actions';
import { LoginDetails } from '../../models/login/login-details.model';
import { Lead } from '../../models/login/lead.model';
import { LocalStoreService } from '../common/local-store/local-store.service';
import { Captcha } from '../../models/login/captcha.model';
import { AdminLoginDetails } from '../../models/login/admin-login-details.model';
import { AdminLoginInfo } from '../../models/login/admin-login-info.model';
import { TokenInfo } from '../../models/login/token-info.model';
import { Router } from '@angular/router';
import { DataObject } from '../../models/common/data.model';
import{PartnerCategory} from '../../models/login/PartnerCategory.model';
import { LPRedirectUrl} from '../../models/login/LPRedirectUrl.model';
@Injectable({
	providedIn: 'root'
})
export class AuthService {

	constructor(
		private api: HdfcApiService,
		private localStore: LocalStoreService,
		private router: Router
	) { }

	doLoginLp(lead: Lead): Observable<LoginDetails> {
		return this.api.post<Lead, LoginDetails>(API_LOGIN_LP, lead);
	}
	doLoginLp2In1(lead: Lead): Observable<LoginDetails> {
		return this.api.post<Lead, LoginDetails>(API_LOGIN_LP_2In1, lead);
	}
	getMobileFromDeviceId(data: DataObject): Observable<DataObject> {
		return this.api.post<DataObject, DataObject>(API_MOBILE_DEVICEID, data);
	}

	insertCred(lead: Lead): Observable<LoginDetails> {
		return this.api.post<Lead, LoginDetails>(API_LOGIN_LP_CRED, lead);
	}

	insertGpay(lead: Lead): Observable<LoginDetails> {
		return this.api.post<Lead, LoginDetails>(API_LOGIN_LP_GPAY, lead);
	}

	insertPhonepe(lead: Lead): Observable<LoginDetails> {
		return this.api.post<Lead, LoginDetails>(API_LOGIN_LP_PHONEPE, lead);
	}

	insertCpl(lead: Lead): Observable<void> {
		return this.api.post<Lead, void>(API_LP_CPL, lead);
	}

	startPartner(lead: Lead): Observable<Lead> {
		return this.api.post<Lead, Lead>(API_START_PARTNER, lead);
	}

	validatePartnerOtp(lead: Lead): Observable<void> {
		return this.api.post<Lead, void>(API_VALIDATE_PARTNER, lead);
	}
	validatePartnerEmailOtp(lead: Lead): Observable<void> {
		return this.api.post<Lead, void>(API_VALIDATE_PARTNEREMAIL, lead);
	}

	insertGpayOffer2(lead: Lead): Observable<LoginDetails> {
		return this.api.post<Lead, LoginDetails>(API_LOGIN_LP_GPAY + 'offer2', lead);
	}

	insertPhonepeOffer2(lead: Lead): Observable<LoginDetails> {
		return this.api.post<Lead, LoginDetails>(API_LOGIN_LP_PHONEPE + 'offer2', lead);
	}

	//#region Admin
	public doLogin(loginDetails: AdminLoginDetails): Observable<AdminLoginInfo> {
		return this.api.postEncrypted<AdminLoginDetails, AdminLoginInfo>(API_LOGIN_ADMIN, loginDetails);
	}

	refreshToken(): Observable<TokenInfo> {
		const loginInfo: TokenInfo = new TokenInfo();
		loginInfo.Token = this.localStore.getToken();
		loginInfo.RefreshToken = this.localStore.getRefreshToken();
		return this.api.post<TokenInfo, TokenInfo>(API_REFRESH_ADMIN, loginInfo, false);
	}

	logout() {
		this.api.get<void>(API_LOGOUT_ADMIN).subscribe(response => {
			this.localStore.reset();
			this.router.navigate(['/login'], { replaceUrl: true });
		});
	}

	isLoggedIn(): boolean {
		const token = this.localStore.getToken();
		return (token && token.length > 0)
	}

	getCaptcha(): Observable<Captcha> {
		return this.api.get<Captcha>(API_CAPTCHA);
	}
	getPartnerCategory(): Observable<Array<PartnerCategory>> {
		return this.api.get<Array<PartnerCategory>>(API_GETPARTNERCATEGORY);
	}

	getstatename(state: string){
		return this.api.post<string,string>(API_GETSTATENAME,state,false);
	}

	lpurldata(): Observable<LPRedirectUrl>{
		return this.api.get<LPRedirectUrl>(API_LPURLDATA);
	}

}
